module.exports = __webpack_public_path__ + "img/generic_01.e57168b6.jpg";